export default {
  userDevices: {},
  attendanceList: [],
  userVideoQuality: 'pc',
  mixerRtspUserList: [],
  userTrialList: null,
}
